"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = testApplicable;

var _every = _interopRequireDefault(require("transmute/every"));

function testApplicable(applicable, applicabilityConfig) {
  if (applicable) {
    if (typeof applicable === 'function') {
      return applicable(applicabilityConfig);
    } else if (applicable.size) {
      return (0, _every.default)(function (test) {
        return test(applicabilityConfig);
      }, applicable);
    }
  }

  return true;
}

module.exports = exports.default;